module.exports = __webpack_public_path__ + "img/pdf_head02.a63a961b.jpg";